import React from "react";
import { useTranslation } from "react-i18next";
import LandingPage from "./LandingPage";
import LandingPageMobile from "./LandingPageMobile";
import { updateBrowserUrl, isMobile } from "../utils";

const LandingPageContainer = (props) => {
  const { i18n } = useTranslation();

  const handleSectionChange = (sectionId) => {
    const currentLanguage = i18n.language || "it";
    updateBrowserUrl(sectionId, currentLanguage);
  };

  const PageComponent = isMobile() ? LandingPageMobile : LandingPage;

  return (
    <PageComponent
      {...props}
      onSectionChange={handleSectionChange}
      i18n={i18n}
    />
  );
};

export default LandingPageContainer;
